import Vue from 'vue';

// Названия полей помесячного плана по доходам
const PLAN_MONTHS = ['january', 'february', 'march', 'april', 'may', 'june',
    'july', 'august', 'september', 'october', 'november', 'december'];

const round1 = (value: number): number => Math.round(value * 10) / 10;

/** Плановое значение месяца (0-11). Источником может быть как строка плана, так и сама строка дерева */
export function planMonthValue(plan: any, month: number): number {
    if (!plan) {
        return 0;
    }
    const value = plan[PLAN_MONTHS[month]];
    if (typeof value === 'number') {
        return value;
    }
    return parseFloat(value) || 0;
}

/**
 * Записывает значение месяца в строку специфики и, для набора "Остатки", раскладывает
 * отрицательную сумму по остаткам плана предыдущих месяцев: сначала съедается план текущего
 * месяца, затем планы предыдущих - от ближнего к дальнему, ни один месяц не уходит ниже своего
 * плана. Повторяет механику расходов (applyMonthChange в newAlterationForm).
 * Если положительного плана с начала года не хватает на всю сумму - не раскладываем,
 * значение остаётся в текущем месяце и его ловит ФЛК6.
 *
 * @param row       строка специфики с month0..month11
 * @param plan      источник помесячного плана (january..december); для дерева это сама строка
 * @param curMonth  индекс текущего месяца справки (0-11)
 * @param fieldName изменённое поле, например month5
 * @param value     введённое пользователем значение
 * @param spread    раскладывать остатки (набор "Остатки") или просто записать значение
 */
export function applyIncomeMonthValue(row: any, plan: any, curMonth: number,
                                      fieldName: string, value: number, spread: boolean): void {
    Vue.set(row, fieldName, value);
    const month = parseInt(fieldName.slice(5), 10);
    if (month !== curMonth) {
        // месяцы после текущего в раскладке не участвуют
        return;
    }
    // предыдущие месяцы раскладываем заново при каждом вводе
    for (let i = curMonth - 1; i > -1; i--) {
        Vue.set(row, `month${i}`, 0);
    }
    if (!spread || value >= 0) {
        return;
    }
    let planSum = 0;
    for (let i = 0; i <= curMonth; i++) {
        const monthPlan = planMonthValue(plan, i);
        if (monthPlan > 0) {
            planSum = round1(planSum + monthPlan);
        }
    }
    if (planSum < Math.abs(value)) {
        return;
    }
    const curPlan = planMonthValue(plan, curMonth) > 0 ? planMonthValue(plan, curMonth) : 0;
    let diff = round1(value + curPlan);
    if (diff >= 0) {
        // сумма укладывается в план текущего месяца - раскладывать нечего
        return;
    }
    Vue.set(row, fieldName, -curPlan);
    for (let i = curMonth - 1; i > -1; i--) {
        const monthPlan = planMonthValue(plan, i);
        if (monthPlan <= 0) {
            continue;
        }
        diff = round1(diff + monthPlan);
        if (diff <= 0) {
            Vue.set(row, `month${i}`, -monthPlan);
        } else {
            Vue.set(row, `month${i}`, -round1(monthPlan - diff));
            break;
        }
    }
}

/** Убирает из копии строки плановые поля - план в наборах хранится отдельно */
export function clearPlanMonths(row: any): any {
    PLAN_MONTHS.forEach((month) => {
        delete row[month];
    });
    return row;
}
